function showEditComment($commentId){
    $('.comment-item[data-id="'+$commentId+'"] .comment-item-content').hide();
    $('.comment-item[data-id="'+$commentId+'"] .comment-item-content-edit').show();    
} 

function showReplyComment( $theTriggerer, data, cb){   
    if($theTriggerer){
        $theTriggerer.css('pointer-events','none');     
    }    
    $.ajax({
        url     : '/partial/' + data.partial,
        data    : data,
        method  : 'GET',
        success: function (data) {
            var newContent = $(data.markup);            

            $theTriggerer.css('pointer-events','auto');  

            if(typeof(cb) !== 'undefined'){
                cb(newContent);
                if($theTriggerer){
                    $theTriggerer.css('pointer-events','auto');
                }
            }
            loading_partial();
            initForm(newContent); 
            $theTriggerer.closest('.comment-item').append(newContent);
        },
        error: function (response) {
            loading_partial();
            if($theTriggerer){
                $theTriggerer.css('pointer-events','auto');
            }
        }
    });
    loading_partial();


} 